/**
 * Rules a password has to meet, read by every DTO that accepts one and every
 * form that collects one.
 *
 * Eleven call sites had this typed as a bare `8` before this existed: seven
 * `@MinLength(8)` decorators across the API and four form-side checks in the
 * two client apps. A policy change (raise it, add a symbol requirement) means
 * editing one number here rather than finding every copy by grep and hoping
 * none were missed -- which is exactly how a form that still accepts a
 * six-character password against an API that now refuses it would happen.
 */
export const PASSWORD_MIN_LENGTH = 8;
